'use strict';

//let ticking = false;

export default function (querySelectorAllParent) {

	// Schedule the function to run at the start of the frame:
	window.requestAnimationFrame(function() {
		onAnimationFrame(querySelectorAllParent);
	});
}

function onAnimationFrame(querySelectorAllParent) {

	//console.time('#TIMING: SetOrUpdateClassOnFirstAndLastNonHiddenChild');	// Todo: TEMP!!!
	{	// Bara för att få en visuell region i editorn:

		const classHidden = '-hidden-child';
		const classNonHidden = '-non-hidden-child';
		const classFirst = '-first-non-hidden-child';
		const classLast = '-last-non-hidden-child';

		let allParentEls = document.querySelectorAll(querySelectorAllParent);


		for (const parentEl of allParentEls)
		{
			// Gå igenom alla hittade parents:

			let firstFound = false;
			let lastEl = undefined;

			let allChildEls = parentEl.children;

			// Måste tyvärr gå igenom alla för att ta bort klasserna från ev tidigare första/sista:
			for (const el of allChildEls)
			{
				// Denna är flyttad (och o-DRYad) till efter property-getningarna i if-satsen nedan, för att you should always batch your style reads and do them first (where the browser can use the previous frame’s layout values) and then do any writes: https://developers.google.com/web/fundamentals/performance/rendering/avoid-large-complex-layouts-and-layout-thrashing#avoid-forced-synchronous-layouts
				//// Ta bort ev classLast på *alla* (tills vi vet vilket som är det sista synliga):
				//// Ta samtidigt bort classFirst så att vi har ett "rent" utgångsläge inför logiken nedan: 
				//el.classList.remove(classFirst, classLast);

				// Visibility (i bemärkelsen display: hidden) check enligt jQuery/https://stackoverflow.com/a/33456469/593779:
				if (!!el.offsetWidth || !!el.offsetHeight || !!el.getClientRects().length)
				{
					// Är synligt:

					el.classList.add(classNonHidden);

					// Ta även bort ev tidigare satt...
					el.classList.remove(classHidden);

					// Ta bort ev classLast på *alla* (tills vi vet vilket som är det sista synliga):
					// Ta samtidigt bort classFirst så att vi har ett "rent" utgångsläge inför logiken nedan: 
					el.classList.remove(classFirst, classLast);

					if (!firstFound)
					{
						// Om det är det första hittade som är synligt:
						el.classList.add(classFirst);
						firstFound = true;
					}

					lastEl = el;	// Så här långt det sista synliga hittade.
				}
				else
				{
					el.classList.add(classHidden);

					// Ta även bort ev tidigare satt...
					el.classList.remove(classNonHidden);

					// Ta bort ev classLast på *alla* (tills vi vet vilket som är det sista synliga):
					// Ta samtidigt bort classFirst så att vi har ett "rent" utgångsläge inför logiken nedan: 
					el.classList.remove(classFirst, classLast);
				}
			}

			if (lastEl)
			{
				// Om ett sista synligt element hittats:
				lastEl.classList.add(classLast);
			}

		}
	}
	//console.timeEnd('#TIMING: SetOrUpdateClassOnFirstAndLastNonHiddenChild');	// Todo: TEMP!!!
}
